import React from 'react';
import { usePress } from 'react-aria';

type PressableChipProps = {
    canPress: boolean;
    onPress: () => void;
    children: React.ReactNode;
};

/**
 * Behaviour wrapper for chips that act immediately on click, with no selection
 * state (e.g. reactions). Clickable while the owning element isn't selected.
 */
const PressableChip: React.FC<PressableChipProps> = ({ canPress, onPress, children }) => {
    const { pressProps } = usePress({
        isDisabled: !canPress,
        onPress,
    });

    return (
        <div
            role="button"
            tabIndex={canPress ? 0 : -1}
            aria-disabled={!canPress}
            className="outline-none"
            onDoubleClick={(event) => event.stopPropagation()}
            {...pressProps}
        >
            {children}
        </div>
    );
};

export default PressableChip;
